<template>    
    <button v-if="currentPathValue" @click="goBackPage">
        <fa :icon="['fal', 'chevron-left']" class="text-2xl text-gray-300" />
    </button>
    <button
    v-if="
            ['xl', 'lg', 'md', 'sm', 'xs'].includes(isDesktop.screenSize.value) &&
            headerStore.header.routeName !== 'contact-boards' &&
            headerStore.header.routeName !== 'property-boards' &&
            !currentPathValue &&
            headerStore.header.routeName !== 'diary-page' &&
            !accounts_routes.includes(headerStore.header.routeName)
            "
        class="bg-gray-100 flex items-center text-gray-300 dark:text-gray-500 px-4 py-[0.4375rem] sm:!p-0 sm:w-auto text-sm font-medium rounded-3xl leading-4 h-[2.5rem] w-[2.5rem] xs:h-[2rem] xs:w-[2rem] xs:px-0 justify-center dark:bg-black-900"
        @click="goBackPage"
        :class="headerStore.header.routeName === 'Inbox' ? 'pl-0 hidden' : ''"
        >
        <fa
        :icon="['fal', 'chevron-left']"
        class="!text-[1.5rem] text-gray-300 dark:text-gray-500"
        :class="headerStore.header.routeName === 'Inbox' ? 'sm:hidden inline' : ''"
        />
        <!-- <span> {{ appSearchString }}</span> -->
    </button>
    <div
        v-if="
            ['sm', 'xs'].includes(isDesktop.screenSize.value) &&
            headerStore.header.routeName !== 'contact-boards' &&
            headerStore.header.routeName !== 'property-boards' &&
            !currentPathValue &&
            headerStore.header.routeName !== 'diary-page' &&
            !accounts_routes.includes(headerStore.header.routeName)
        "
        class="accordion_menu"
    >
        <fa :icon="['fal', 'bars']" @click="classAdd()" />
    </div>
    <div v-if="currentPathValue" class="flex">
        <div v-if="route.name === 'property.board.detail'" class="flex-column">
            <div
                v-if="propertyName"
                class="truncate text-lg font-semibold leading-[22px] text-black-600 mb-[2px]"
                >
                {{
                    truncateFunction(
                    `£${propertyName.price || ""} - ${propertyName.bedrooms || ""} bed ${propertyName.property_type_name || ""} for ${propertyName.sale_bool || ""}`
                    )
                }}
                </div>

            <div
                v-if="propertyName && (
                    propertyName.address_line_1 ||
                    propertyName.address_line_2 ||
                    propertyName.town ||
                    propertyName.country ||
                    propertyName.postcode
                    )"
                class="!text-xs !font-normal text-black-600 !leading-[15px]"
                >
                {{
                    truncateFunction(
                    `${propertyName.address_line_1 ? propertyName.address_line_1 + ", " : ""}` +
                    `${propertyName.address_line_2 ? propertyName.address_line_2 + ", " : ""}` +
                    `${propertyName.town ? propertyName.town + ", " : ""}` +
                    `${propertyName.country ? propertyName.country + ", " : ""}` +
                    `${propertyName.postcode || ""}`
                    )
                }}
                </div>

        </div>
        <MutliContactNameIcon
            v-if="route.name === 'contact.board.detail'"
            :data="headerStore.header.userName"
            badge-class=""
            name-text=""
            :is-large="true"
            :contact-board-name="boardStore.getCurrentBoard"
            name-letter=""
            last-name-letter=""
            :is-full="true"
        />
    </div>
    <!-- :class="[boardStore.getCurrentBoard =='Inbox'?'hide':''] -->
    <div v-else :class="{ hidden: isDesktop.screenSize.value === 'xs' }">
        <span class="main_heading">
            {{ boardStore.getCurrentBoard }}
        </span>
    </div>
</template>

<script setup>
// Vue imports
import { onMounted, ref, computed, nextTick } from "vue";

// Vue router
import { useRoute, useRouter } from "vue-router";

// Pinia store imports
import { storeToRefs } from "pinia";
import { useBoardStore } from "@/stores/boardStore";
import { useHeaderStore } from "@/stores/headerStore";
import { useAppSearchStore } from "@/stores/appSearchStore";

// Composable imports
import { useScreenSize } from "@/composables/globals";

// Components import
import MutliContactNameIcon from "@/components/contacts/MutliContactNameIcon.vue";

const boardStore = useBoardStore();
const headerStore = useHeaderStore();
const searchStore = useAppSearchStore();

const accounts_routes = ["client-account", "deposit-account", "deposit-custodial", "money-in", "money-out", "floats"];

const isDesktop = useScreenSize();

const { appSearchString } = storeToRefs(searchStore);

const route = useRoute();
const router = useRouter();

const goBackPage = () => {
    router.back();
};

const currentPath = ref("");

onMounted(() => {
    nextTick(() => {
        currentPath.value = route.name || "";
    });
    // handleResize(); // Initial check
    // window.addEventListener('resize', handleResize); // Listen for window resize
});

const propertyName = computed(() => {
    for (const step of boardStore.propertyBoard.steps) {
        if (step.properties && step.properties.length) {
            const property = step.properties.find((prop) => prop.id === parseInt(route.params.propertyId));
            if (property) {
                return property;
            }
        }
    }
    return null;
});

const currentPathValue = computed(() => {
    return route.name === "contact.board.detail" || route.name === "property.board.detail";
});

const truncateFunction = (val) => {
    if (window.innerWidth <= 1025) {
        return val.length > 20 ? `${val.substring(0, 20)}...` : val;
    } else {
        return val;
    }
};

let accordionShow = ref(null);

const classAdd = () => {
    if (screen.width <= 768) {
        accordionShow.value.classList.toggle("active");
    } else if (accordionShow.value.classList.contains("active")) {
        accordionShow.value.classList.remove("active");
    } else {
        accordionShow.value.classList.remove("active");
    }
};
</script>

<style scoped>
.accordion_menu {
    @apply xs:leading-4;
}

.accordion_menu svg {
    @apply text-2xl w-[1.3125rem] xs:w-[1.25rem] xs:h-[1.125rem] xs:text-gray-300 xs:bg-gray-100 xs:p-[0.375rem] xs:rounded-3xl h-[1.5rem] cursor-pointer
    dark:text-white pt-[0.375rem];
}

.topbar_heading {
    @apply text-black-900 dark:text-dm-white text-lg font-bold leading-4;
}

.main_heading {
    @apply text-black-600 dark:text-white text-lg font-semibold;
}

.card-name {
    @apply text-xs text-gray-500 leading-3;
}

.name_icon__letter_text {
    @apply inline-flex items-center justify-center rounded-full mr-[-0.5rem] text-white relative text-lg;
}

@media only screen and (max-width: 1270px) {
    .hide {
        @apply hidden;
    }
}
</style>
